/* eslint-disable @typescript-eslint/no-deprecated */ // TODO: Replace `currency` with `formatCurrency` function
import { units } from '@dynatrace-sdk/units';

import { TimeseriesUnit } from '../charts/core/types/timeseries.js';

/** This is the mapping between old grail metrics and their units as well new ones in one object.
 * For reference: https://bitbucket.lab.dynatrace.org/projects/DEUS/repos/universal-units/browse/src/main/java/com/dynatrace/metrics/units/identifier/UnitId.java */
const mapping = {
  // SI units
  s: units.time.second,
  m: units.length.meter,
  kg: units.mass.kilogram,
  A: units.electricity.ampere,
  K: units.temperature.kelvin,
  mol: 'mol',
  cd: units.physics.candela,
  Second: units.time.second,
  Metre: units.length.meter,
  Kilogram: units.mass.kilogram,
  Ampere: units.electricity.ampere,
  Kelvin: units.temperature.kelvin,
  Mole: 'mol',
  Candela: units.physics.candela,
  //time
  ns: units.time.nanosecond,
  us: units.time.microsecond,
  ms: units.time.millisecond,
  NanoSecond: units.time.nanosecond,
  MicroSecond: units.time.microsecond,
  MilliSecond: units.time.millisecond,
  min: units.time.minute,
  h: units.time.hour,
  d: units.time.day,
  wk: units.time.week,
  mo: units.time.month,
  a: units.time.year,
  Minute: units.time.minute,
  Hour: units.time.hour,
  Day: units.time.day,
  Week: units.time.week,
  Month: units.time.month,
  Year: units.time.year,
  // time squared
  SquareSecond: units.time_squared.square_second,
  SquaredSecond: units.time_squared.square_second,
  s2: units.time_squared.square_second,
  // length
  '[in_i]': units.length.inch,
  '[ft_i]': units.length.foot,
  '[yd_i]': units.length.yard,
  '[mi_i]': units.length.mile,
  Inch: units.length.inch,
  Foot: units.length.foot,
  Yard: units.length.yard,
  Mile: units.length.mile,
  // area
  m2: units.area.square_meter,
  '[sin_i]': units.area.square_inch,
  '[sft_i]': units.area.square_foot,
  '[syd_i]': units.area.square_yard,
  '[smi_us]': units.area.square_mile,
  SquareMetre: units.area.square_meter,
  SquareInch: units.area.square_inch,
  SquareFoot: units.area.square_foot,
  SquareYard: units.area.square_yard,
  SquareMile: units.area.square_mile,
  // volume
  m3: units.volume.cubic_meter,
  '[cin_i]': units.volume.cubic_inch,
  '[cft_i]': units.volume.cubic_foot,
  l: units.volume.litre,
  CubicMetre: units.volume.cubic_meter,
  CubicInch: units.volume.cubic_inch,
  CubicFoot: units.volume.cubic_foot,
  Litre: units.volume.litre,
  // frequency
  Hz: units.frequency.hertz,
  Hertz: units.frequency.hertz,
  // mass
  g: units.mass.gram,
  t: units.mass.tonne,
  '[lb_av]': units.mass.pound,
  Gram: units.mass.gram,
  Tonne: units.mass.tonne,
  Pound: units.mass.pound,
  // force
  N: units.force.newton,
  '[lbf_av]': units.force.pound,
  Newton: units.force.newton,
  PoundForce: units.force.pound,
  // energy
  J: 'J',
  Wh: 'Wh',
  kWh: 'kWh',
  W: units.electricity.watt,
  Joule: 'J',
  WattHour: 'Wh',
  KiloWattHour: 'kWh',
  Watt: units.electricity.watt,
  // pressure
  Pa: units.pressure.pascal,
  kPa: units.pressure.kilopascal,
  '[lbf_av]/[sin_i]': 'psi',
  bar: units.pressure.bar,
  Pascal: units.pressure.pascal,
  KiloPascal: units.pressure.kilopascal,
  PoundForcePerSquareInch: 'psi',
  Bar: units.pressure.bar,
  // electricity
  V: units.electricity.volt,
  Ω: units.electricity.ohm,
  Volt: units.electricity.volt,
  Ohm: units.electricity.ohm,
  // acceleration
  'm/s2': 'm/s²',
  '[ft_i]/s2': 'ft/s²',
  MetrePerSecondSquared: 'm/s²',
  FootPerSecondSquared: 'ft/s²',
  'm/s': units.velocity.meter_per_second,
  MetrePerSecond: units.velocity.meter_per_second,
  'm/h': 'm/h',
  MetrePerHour: 'm/h',
  'km/h': units.velocity.kilometer_per_hour,
  KiloMetrePerHour: units.velocity.kilometer_per_hour,
  USD: units.currency.usd,
  EUR: units.currency.eur,
  JPY: units.currency.jpy,
  GBP: units.currency.gbp,
  AUD: units.currency.aud,
  CAD: units.currency.cad,
  CHF: units.currency.chf,
  CNY: units.currency.cny,
  UnitedStatesDollar: units.currency.usd,
  Euro: units.currency.eur,
  BritishPound: units.currency.gbp,
  AustralianDollar: units.currency.aud,
  CanadianDollar: units.currency.cad,
  SwissFranc: units.currency.chf,
  'chinese yuan': units.currency.cny,
  // temperature
  Cel: units.temperature.degree_celsius,
  '[degF]': units.temperature.degree_fahrenheit,
  '[degR]': units.temperature.degree_rankine,
  Celsius: units.temperature.degree_celsius,
  Fahrenheit: units.temperature.degree_fahrenheit,
  Rankine: units.temperature.degree_rankine,
  // information
  bit: units.data.bit,
  kbit: units.data.kilobit,
  Kibit: units.data.kibibit,
  Mbit: units.data.megabit,
  Mibit: units.data.mebibit,
  Gbit: units.data.gigabit,
  Gibit: units.data.gibibit,
  Bit: units.data.bit,
  KiloBit: units.data.kilobit,
  KibiBit: units.data.kibibit,
  MegaBit: units.data.megabit,
  MebiBit: units.data.mebibit,
  GigaBit: units.data.gigabit,
  GibiBit: units.data.gibibit,
  By: units.data.byte,
  kBy: units.data.kilobyte,
  KiBy: units.data.kibibyte,
  MBy: units.data.megabyte,
  MiBy: units.data.mebibyte,
  GBy: units.data.gigabyte,
  GiBy: units.data.gibibyte,
  Byte: units.data.byte,
  KiloByte: units.data.kilobyte,
  KibiByte: units.data.kibibyte,
  MegaByte: units.data.megabyte,
  MebiByte: units.data.mebibyte,
  GigaByte: units.data.gigabyte,
  GibiByte: units.data.gibibyte,
  // information over time
  'By/s': units.datarate.Bps,
  'By/min': units.datarate.Bpm,
  'By/h': units.datarate.Bph,
  'bit/s': units.datarate.bitps,
  'bit/min': units.datarate.bitpm,
  'bit/h': units.datarate.bitph,
  BytePerSecond: units.datarate.Bps,
  BytePerMinute: units.datarate.Bpm,
  BytePerHour: units.datarate.Bph,
  BitPerSecond: units.datarate.bitps,
  BitPerMinute: units.datarate.bitpm,
  BitPerHour: units.datarate.bitph,

  'kbit/s': units.datarate.kbitps,
  'kBit/min': units.datarate.kbitpm,
  'kBit/h': units.datarate.kbitph,
  'kBy/s': units.datarate.kBps,
  'kBy/min': units.datarate.kBpm,
  'kBy/h': units.datarate.kBph,
  'Kibit/s': units.datarate.kibitps,
  'KiBit/min': units.datarate.kbitpm,
  'KiBit/h': units.datarate.kibitph,
  'KiBy/s': units.datarate.kiBps,
  'KiBy/min': units.datarate.kiBpm,
  'KiBy/h': units.datarate.kiBph,
  'Mbit/s': units.datarate.Mbitps,
  'Mbit/min': units.datarate.Mbitpm,
  'Mbit/h': units.datarate.Mbitph,
  'MBy/s': units.datarate.MBps,
  'MBy/min': units.datarate.MBpm,
  'MBy/h': units.datarate.MBph,
  'Mibit/s': units.datarate.Mibitps,
  'Mibit/min': units.datarate.Mibitpm,
  'Mibit/h': units.datarate.Mibitph,
  'MiBy/s': units.datarate.MiBps,
  'MiBy/min': units.datarate.MiBpm,
  'MiBy/h': units.datarate.MiBph,
  'Gbit/s': units.datarate.Gbitps,
  'Gbit/min': units.datarate.Gbitpm,
  'Gbit/h': units.datarate.Gibitph,
  'GBy/s': units.datarate.GBps,
  'GBy/min': units.datarate.GBpm,
  'GBy/h': units.datarate.GBph,
  'Gibit/s': units.datarate.Gibitps,
  'Gibit/min': units.datarate.Gibitpm,
  'Gibit/h': units.datarate.Gibitph,
  'GiBy/s': units.datarate.GiBps,
  'GiBy/min': units.datarate.GiBpm,
  'GiBy/h': units.datarate.GiBph,

  KiloBitPerSecond: units.datarate.kbitps,
  KiloBitPerMinute: units.datarate.kbitpm,
  KiloBitPerHour: units.datarate.kbitph,
  KiloBytePerSecond: units.datarate.kBps,
  KiloBytePerMinute: units.datarate.kBpm,
  KiloBytePerHour: units.datarate.kBph,
  KibiBitPerSecond: units.datarate.kibitps,
  KibiBitPerMinute: units.datarate.kbitpm,
  KibiBitPerHour: units.datarate.kibitph,
  KibiBytePerSecond: units.datarate.kiBps,
  KibiBytePerMinute: units.datarate.kiBpm,
  KibiBytePerHour: units.datarate.kiBph,
  MegaBitPerSecond: units.datarate.Mbitps,
  MegaBitPerMinute: units.datarate.Mbitpm,
  MegaBitPerHour: units.datarate.Mbitph,
  MegaBytePerSecond: units.datarate.MBps,
  MegaBytePerMinute: units.datarate.MBpm,
  MegaBytePerHour: units.datarate.MBph,
  MebiBitPerSecond: units.datarate.Mibitps,
  MebiBitPerMinute: units.datarate.Mibitpm,
  MebiBitPerHour: units.datarate.Mibitph,
  MebiBytePerSecond: units.datarate.MiBps,
  MebiBytePerMinute: units.datarate.MiBpm,
  MebiBytePerHour: units.datarate.MiBph,
  GigaBitPerSecond: units.datarate.Gbitps,
  GigaBitPerMinute: units.datarate.Gbitpm,
  GigaBitPerHour: units.datarate.Gibitph,
  GigaBytePerSecond: units.datarate.GBps,
  GigaBytePerMinute: units.datarate.GBpm,
  GigaBytePerHour: units.datarate.GBph,
  GibiBitPerSecond: units.datarate.Gibitps,
  GibiBitPerMinute: units.datarate.Gibitpm,
  GibiBitPerHour: units.datarate.Gibitph,
  GibiBytePerSecond: units.datarate.GiBps,
  GibiBytePerMinute: units.datarate.GiBpm,
  GibiBytePerHour: units.datarate.GiBph,
  // count
  count: 'count',
  's/min': 's/min',
  Count: 'count',
  // count over time
  'count/s': 'count/s',
  'count/min': 'count/min',
  'count/h': 'count/h',
  '[ppth]': units.percentage.per_mille,
  'ms/min': 'ms/min',
  'ns/min': 'ms/min',
  MilliSecondPerMinute: 'ms/min',
  NanoSecondPerMinute: 'ns/min',
  PerSecond: 'count/s',
  PerMinute: 'count/min',
  PerHour: 'count/h',
  core: 'core',
  Cores: 'core',
  MilliCores: 'mcore',
  px: 'px',
  Pixel: 'px',
  msu: 'msu',
  MSU: 'msu',
  ratio: 'ratio',
  Ratio: 'ratio',
  Percent: units.percentage.percent,
  '%': units.percentage.percent,
  Promille: units.percentage.per_mille,
  state: 'state',
  State: 'state',
  Decibel: 'dB',
  dBm: 'dBm',
  DecibelMilliWatt: 'dBm',
  Unspecified: 'unspecified',
} as const;

/** @internal */
export function mapMetricUnitToSdk(unitId: string): TimeseriesUnit | undefined {
  if (unitId === 'Unspecified') {
    return undefined;
  }

  return mapping[unitId as keyof typeof mapping] ?? unitId;
}
